module.exports = __webpack_public_path__ + "static/media/FairmaxLogoLight.27f3dac8.png";